import React from 'react';
import './RadixConnect.scss';

const RadixConnectWithContext = () => {
  return (
    <div className="radix-connect-container">
      <radix-connect-button />
    </div>
  );
};

export default RadixConnectWithContext; 